import React, { ButtonHTMLAttributes, forwardRef, ReactNode } from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { AnalyticsHtmlButton } from './AnalyticButton';
import { IButtonAnalyticsProps } from './types';

interface IProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    IButtonAnalyticsProps {
  children: ReactNode;
}

const Action = styled(AnalyticsHtmlButton)`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  align-self: start;
  column-gap: 4px;
  border: 0;
  padding: 0;
  font: inherit;
  font-weight: 400;
  background: none;
  outline: none;
  color: ${theme.colors.secondary800};
  transition: color 0.2s ease-in-out;
  &:not(:disabled):hover {
    color: ${theme.colors.mainBlue};
    cursor: pointer;
  }
  &:disabled {
    color: ${theme.colors.secondary400};
  }
`;

const TextButton = forwardRef<HTMLButtonElement, IProps>(
  ({ children, type = 'button', ...props }, ref) => (
    <Action {...props} type={type} ref={ref}>
      {children}
    </Action>
  ),
);

export default TextButton;
